import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { FormService } from '../../../common/services/form.service';
import { formatDate, NgClass } from '@angular/common';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { ClientField } from '../../../common/models/client-field.model';
import { FocusDirective } from '@sb-tools/typescript/directives/focus.directive';
import { TranslateModule } from '@ngx-translate/core';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { InlineSVGComponent } from '../../../../Frontend-Inline-SVG-Module/inline-svg.component';

@Component({
    selector: 'sb-date',
    templateUrl: './date.component.html',
    styleUrls: ['./date.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [
        NgClass,
        FocusDirective,
        FormsModule,
        TranslateModule,
        TimepickerModule,
        BsDatepickerModule,
        InlineSVGComponent,
    ],
})
export class DateComponent implements OnInit {
    @Input() formField: Field | ClientField;

    date: Date;
    dateTime: Date;
    isDateTime: boolean;
    isTimeValid = true;
    time: Date;

    constructor(
        public formService: FormService,
        private ngForm: NgForm,
    ) {}

    ngOnInit() {
        this.isDateTime = this.formField.options && this.formField.options.isDateTime === 'true';

        if (this.formField.value && typeof this.formField.value === 'string') {
            this.initPreselectedValue();

            if (this.formField.defaultValue && this.formField.value !== this.formField.defaultValue && !this.date) {
                this.formField.value = this.formField.defaultValue;
                this.initPreselectedValue();
            }

            this.updateDate();
        } else if (!this.formField.value && this.isDateTime && this.formField.options?.defaultTime) {
            this.setDefaultTime();
        }
    }

    updateDate() {
        if (this.date) {
            if (this.formField.options?.isDateTime === 'true') {
                if (this.time) {
                    this.dateTime = this.getDateTime(this.date, this.time);
                } else {
                    this.dateTime = this.formField.isRequired ? null : this.date;
                }
            } else {
                this.dateTime = this.date;
            }
        } else {
            this.dateTime = null;
        }

        this.formField.value = this.dateTime ? this.convertDateToISOFormat(this.dateTime) : '';
        this.triggerFormValueChanges();
    }

    updateTime(time) {
        this.time = time;

        if (this.time) {
            if (this.date) {
                this.dateTime = this.getDateTime(this.date, this.time);
            }
        } else {
            if (this.formField.isRequired) {
                this.dateTime = null;
            } else {
                if (this.date) {
                    this.dateTime = this.date;
                } else {
                    this.dateTime = null;
                }
            }
        }

        this.formField.value = this.dateTime ? this.convertDateToISOFormat(this.dateTime) : '';
        this.triggerFormValueChanges();
    }

    private convertDateToISOFormat(date) {
        if (this.formField.options?.isDateTime === 'true' && this.time) {
            return date.toISOString();
        } else {
            return formatDate(date, 'yyyy-MM-dd', 'en-US');
        }
    }

    private getDateTime(date: Date, time: Date): Date {
        if (date == null) {
            date = new Date();
        }
        if (time == null) {
            time = new Date();
        }
        return new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            time.getHours(),
            time.getMinutes(),
            time.getSeconds(),
            time.getMilliseconds(),
        );
    }

    private initPreselectedValue() {
        let customFieldValue = new Date(this.formField.value) as any;

        if (customFieldValue == 'Invalid Date') {
            let dateParts = this.formField.value.split('-') as any;

            if (dateParts.length >= 3) {
                customFieldValue = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
            } else {
                dateParts = this.formField.value.split('.');

                if (dateParts.length >= 3) {
                    customFieldValue = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
                } else {
                    customFieldValue = null;
                }
            }
        }

        const isTimeSet = this.formField.value.indexOf('T') > -1;

        if (isTimeSet) {
            this.time = customFieldValue == 'Invalid Date' ? null : customFieldValue;
        }

        this.date = customFieldValue == 'Invalid Date' ? null : customFieldValue;
    }

    private setDefaultTime() {
        const hh = this.formField.options?.defaultTime.split(':')[0];
        const mm = this.formField.options?.defaultTime.split(':')[1];
        this.time = new Date(new Date().setHours(hh, mm));
    }

    private triggerFormValueChanges(): void {
        this.ngForm.form.updateValueAndValidity({ onlySelf: false, emitEvent: true });
    }
}
